<template>
<section class="concept-section _edit-section">

    <div class="section-inner">
        <div class="concept-item">
            <h2 class="heading-section">{{getNameConcept}} Concept</h2>
            <textarea maxlength="250" name="edit-concept" id="edit-concept1" class="edit-pen" :placeholder="getName + 'のコンセプトを250文字以内で入力してください'" v-model="concept" v-bind:class="{ '_error': this.$store.state.register.errors.concept }"></textarea>
            <span style="color: red" v-if="$store.state.register.errors.concept && concept.length<=250">必須項目を入力してください</span>
            <span style="color: red" v-if="$store.state.register.errors.concept && concept.length>250">コンセプトを250文字以内で入力してください</span>
        </div>
    </div>

</section><!--/.page-name-row-->
</template>

<script>

export default {
    data() {
        return {
            concept: '',
        };
    },
    created() {
        // 編集の場合
        if (this.$store.state.detail.set.brand.concept) {
            this.concept = this.$store.state.detail.set.brand.concept;
            this.$store.state.register.form.concept = this.$store.state.detail.set.brand.concept;
        }
    },
    watch: {
        concept: function (value) {
            this.$store.state.register.form.concept = value;
        }
    },
    computed: {
        getName() {
            var url = location.pathname;
            if (url.indexOf( '/brand' ) != -1) {
                return 'ブランド';
            } else if (url.indexOf( '/shop' ) != -1) {
                return 'ショップ';
            } else if (url.indexOf( '/showroom' ) != -1) {
                return 'ショールーム';
            }
        },
        getNameConcept() {
            var url = location.pathname;
            if (url.indexOf( '/brand' ) != -1) {
                return 'Brand';
            } else if (url.indexOf( '/shop' ) != -1) {
                return 'Shop';
            } else if (url.indexOf( '/showroom' ) != -1) {
                return 'ShowRoom';
            }
        },
    }
};
</script>